import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  display: flex;
  gap: 40px;
  justify-content: space-between;
  margin-bottom: 41px;
  width: 100%;
  padding: 0px 53px;
  margin-bottom: 14px;
`
